import { useRouteError } from 'react-router'
import { Button, ButtonLink, Card } from '../design/components'
import { Icon } from '../design/icons'
import { useT } from '../i18n'
import styles from './app.module.css'

/** Shown when a screen crashes. Plain, blameless, with a way forward (no flavor on errors). */
export function AppErrorPage() {
  const t = useT()
  return (
    <main id="main" className={styles.errorPage} data-audience="public">
      <Card padding="lg" className={styles.errorCard}>
        <Icon name="warning" size={32} className={styles.errorIcon} />
        <h1 className={styles.errorTitle}>{t.common.boundary.title}</h1>
        <p>{t.common.boundary.body}</p>
        <div className={styles.errorActions}>
          <Button variant="primary" icon="refresh" onClick={() => window.location.reload()}>
            {t.common.actions.reload}
          </Button>
          <ButtonLink href="/" icon="home">
            {t.common.actions.goHome}
          </ButtonLink>
        </div>
      </Card>
    </main>
  )
}

/** Router-level errors (for example a screen's code failing to download after an update). */
export function RouteErrorPage() {
  const error = useRouteError()
  console.error('Galley route error', error)
  return <AppErrorPage />
}
